// @core/api/endpoints/analytics/get_dashboard.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DashboardResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Get dashboard by ID
 * Retrieves a dashboard with its layout configuration. Widget data must be fetched separately via QueryData.
 */
export async function GetDashboard(
  dashboard_id: string,
  options?: RequestOptions
): Promise<DashboardResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/dashboards/:dashboard_id`;
  requestPath = requestPath.replace(':dashboard_id', encodeURIComponent(dashboard_id));
  const requestOptions = options;
  return client.get<DashboardResponse>(requestPath, { ...requestOptions });
}
